import resume from '../assets/pdf/resume.pdf'
import profile from '../assets/png/me3-min.png'

export const headerData = {
    name: 'Boniface Ngugi',
    title: "Software Developer",
    desciption:"Any sufficiently advanced technology is indistinguishable from magic - Arthur C. Clarke ",
    //image: 'https://raw.githubusercontent.com/PhantomScript/asset-container/main/developer-portfolio/landingImg.png',
    image: profile,
    resumePdf: resume
}
